module.exports = __webpack_public_path__ + "img/960.12bf149f.svg";